<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<div class="page-header">
  <h2>Grupos Econômicos</h2>
  <app-button
    *appHasRole="'TENANT'"
    label="Novo Grupo"
    icon="pi pi-plus"
    (sendButtonClick)="openCreate()" />
</div>

@if (loading()) {
  <app-loading />
}

@if (!loading()) {
  <app-table
    [items]="groups()"
    [columnDefinitions]="columnDefinitions"
    [getOptionsFunction]="getMenuActions.bind(this)"
    [paginator]="true"
    [rows]="20"
    [totalRecords]="total()">
    <ng-template appNamedTemplate="companySectorName" let-item>
      @if (item.companySectorName) {
        {{ item.companySectorName }}
      } @else {
        <span class="group-muted">Sem setor</span>
      }
    </ng-template>
  </app-table>
}

<app-create-edit-group-modal #createEditModal (saved)="onGroupSaved()" />
